import { Head } from "@inertiajs/react"
import { Check } from "lucide-react"

import { AuthHeading, HeroIcon } from "@/components/tuw/auth/AuthHeading"
import AuthLayout from "@/components/tuw/auth/AuthLayout"
import { Button } from "@/components/ui/button"

// Password updated (P11-H2 Spare Key). Devise signs the user in after a
// successful reset, so this is the flow's one signed-in screen and it
// continues into the app rather than back to sign in. Changing the password
// invalidates every other session's key, hence the second sentence.
export default function ResetDone({ links }) {
  return (
    <AuthLayout panel="reset">
      <Head title="Password updated · The Urban Writers" />

      <HeroIcon icon={Check} ok />
      <AuthHeading title="Password updated">
        You’re signed in on this device. Other sessions will need the new password.
      </AuthHeading>

      <Button asChild className="h-auto w-full rounded-[11px] px-4 py-3 text-[14px] font-semibold">
        <a href={links.dashboard}>Continue to dashboard</a>
      </Button>
    </AuthLayout>
  )
}
